import React from "react";
import { useFormContext } from "./Form";
import useField, { fieldPropTypes } from "./field";

const Textarea = (props) => {
    const context = useFormContext();
    const { key, errors, fieldProps } = useField(props, context);

    return [
        <textarea key={key} { ...fieldProps }></textarea>,
        ...errors.elements,
    ];
};

Textarea.propTypes = {
    ...fieldPropTypes,
};

export default Textarea;